import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    timeout: 120000,
});

// Injeta token em toda chamada
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("linkia_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Trata 401 globalmente
api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("linkia_token");
            localStorage.removeItem("linkia_user");
            if (!window.location.pathname.startsWith("/login")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);

export const auth = {
    register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
    login:    (payload) => api.post("/auth/login", payload).then((r) => r.data),
    me:       ()        => api.get("/auth/me").then((r) => r.data),
};

export const app = {
    tokens: () => api.get("/app/me/tokens").then((r) => r.data),
    updateProfile: (payload) => api.put("/app/me/profile", payload).then((r) => r.data),
    deleteAllTasks: () => api.delete("/app/ai/tasks").then((r) => r.data),
    listTasks: (limit = 100) =>
        api.get(`/app/ai/tasks`, { params: { limit } }).then((r) => r.data),
    status: (taskId, opts = {}) => {
        const params = { verbose: "true", ...opts };
        return api.get(`/app/ai/status/${taskId}`, { params }).then((r) => r.data);
    },
    create: (body) =>
        api.post("/app/ai/create", body).then((r) => r.data),
    upload: (files, scope = "chat") => {
        const form = new FormData();
        for (const f of files) form.append("files", f);
        form.append("scope", scope);
        return api
            .post("/app/upload", form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 300000,
            })
            .then((r) => r.data);
    },
};

export const agents = {
    list:   ()          => api.get("/app/agents").then((r) => r.data),
    create: (payload)   => api.post("/app/agents", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/app/agents/${id}`, payload).then((r) => r.data),
    remove: (id)        => api.delete(`/app/agents/${id}`).then((r) => r.data),
};

// Bloco de notas do usuário — lista traz só preview; GET /:id traz o conteúdo completo
export const notes = {
    list:   (q)           => api.get("/app/notes", { params: q ? { q } : {} }).then((r) => r.data),
    get:    (id)          => api.get(`/app/notes/${id}`).then((r) => r.data),
    create: (payload)     => api.post("/app/notes", payload).then((r) => r.data),
    update: (id, payload) => api.put(`/app/notes/${id}`, payload).then((r) => r.data),
    remove: (id)          => api.delete(`/app/notes/${id}`).then((r) => r.data),
};

// Pipeline de bots encadeados (estilo n8n)
export const bots = {
    list:      (groupId)     => api.get("/app/bots", { params: groupId ? { group_id: groupId } : {} }).then((r) => r.data),
    create:    (payload)     => api.post("/app/bots", payload).then((r) => r.data),
    update:    (id, payload) => api.put(`/app/bots/${id}`, payload).then((r) => r.data),
    remove:    (id)          => api.delete(`/app/bots/${id}`).then((r) => r.data),
    createRun: (payload)     => api.post("/app/bot-runs", payload).then((r) => r.data),
    listRuns:  ()            => api.get("/app/bot-runs").then((r) => r.data),
    getRun:    (id)          => api.get(`/app/bot-runs/${id}`).then((r) => r.data),
    pauseRun:  (id)          => api.post(`/app/bot-runs/${id}/pause`).then((r) => r.data),
    resumeRun: (id)          => api.post(`/app/bot-runs/${id}/resume`).then((r) => r.data),
    stopRun:   (id)          => api.post(`/app/bot-runs/${id}/stop`).then((r) => r.data),
    removeRun: (id)          => api.delete(`/app/bot-runs/${id}`).then((r) => r.data),
    listGroups:  ()            => api.get("/app/bot-groups").then((r) => r.data),
    createGroup: (payload)     => api.post("/app/bot-groups", payload).then((r) => r.data),
    updateGroup: (id, payload) => api.put(`/app/bot-groups/${id}`, payload).then((r) => r.data),
    removeGroup: (id)          => api.delete(`/app/bot-groups/${id}`).then((r) => r.data),
};

// Helper: dado o retorno de /status, decide se a IA já terminou
export function isTaskFinished(statusResp) {
    const events = statusResp?.linkia?.messages || [];
    return events.some(
        (e) => e?.type === "status_update" && e?.status_update?.agent_status === "stopped"
    );
}
